import { useLang } from "@/i18n/LanguageContext";
import { ArrowRight } from "lucide-react";

const toneBg: Record<string, string> = {
  mint: "bg-mint text-mint-foreground",
  coral: "bg-coral text-coral-foreground",
  butter: "bg-butter text-butter-foreground",
  lavender: "bg-lavender text-lavender-foreground",
};

const BuyerSellerFlow = () => {
  const { t } = useLang();
  return (
    <section id="flow" className="py-24 md:py-32 bg-background">
      <div className="container">
        <div className="grid lg:grid-cols-12 gap-8 items-end">
          <div className="lg:col-span-4">
            <span className="text-xs font-bold uppercase tracking-[0.2em] text-primary-glow">{t.flow.eyebrow}</span>
          </div>
          <div className="lg:col-span-8">
            <h2 className="text-3xl sm:text-4xl md:text-6xl font-extrabold leading-[1.05]">{t.flow.title}</h2>
            <p className="mt-5 text-lg md:text-xl text-muted-foreground max-w-2xl">{t.flow.desc}</p>
          </div>
        </div>

        <div className="mt-16 grid md:grid-cols-3 gap-6">
          {t.flow.steps.map((s, i) => (
            <div key={s.num} className="relative">
              <div className={`rounded-3xl p-7 h-full ${toneBg[s.tone]}`}>
                <div className="text-xs font-extrabold tracking-widest opacity-60">{s.num}</div>
                <h3 className="mt-3 text-2xl font-extrabold leading-tight">{s.title}</h3>
                <p className="mt-3 text-sm opacity-80">{s.desc}</p>
                <div className="mt-6 rounded-2xl bg-background/70 backdrop-blur p-4">
                  <div className="h-2 w-2/3 rounded-full bg-foreground/15" />
                  <div className="mt-2 h-2 w-1/2 rounded-full bg-foreground/10" />
                  <div className="mt-4 grid grid-cols-3 gap-2">
                    {[0, 1, 2].map((k) => (
                      <div key={k} className="aspect-square rounded-lg bg-foreground/5" />
                    ))}
                  </div>
                </div>
              </div>
              {i < t.flow.steps.length - 1 && (
                <div className="hidden md:flex absolute top-1/2 -right-4 -translate-y-1/2 h-8 w-8 items-center justify-center rounded-full bg-background border border-border shadow-card">
                  <ArrowRight className="h-4 w-4" />
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default BuyerSellerFlow;
